const firstElIsKeyvisualExtra = document.querySelector(
    '.before-content > .opendxp_area_keyvisual-extra:first-child'
);
const headerEl = document.querySelector('header');

if (firstElIsKeyvisualExtra && headerEl) {
    const scrollCheck = () => {
        const method = window.scrollY > 100 ? 'add' : 'remove';
        headerEl.classList[method]('scrolled');
    };
    window.addEventListener('scroll', scrollCheck);
    scrollCheck();
}
